import styled from '@emotion/styled';
import { css } from '@emotion/react';

import COLORS, { COLORS_LINK, COLORS_BACKGROUND } from '@zola/zola-ui/src/styles/emotion/colors';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import ZINDEX from '@zola/zola-ui/src/styles/emotion/zIndex';

import NavLogo from 'components/navV2/NavLogo';
import { COLORS3, FONT } from '@zola/zola-ui/src/styles/emotion';

export const Nav = styled.nav`
  background-color: ${COLORS_BACKGROUND.WHITE};
  z-index: ${ZINDEX.super};
`;

export const TopNavBar = styled.div`
  padding: 18px ${SPACING.MD};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
`;

export const StyledNavLogo = styled(NavLogo)`
  margin-right: auto;
  img {
    width: 130px;
    @media (max-width: 320px) {
      width: 111px;
    }
  }
`;

export const SharedIconStyles = css`
  color: ${COLORS_LINK.SECONDARY}!important; // always gray, even on hover or click
  margin-left: 16px;
  height: 24px;
`;

export const SharedIconStylesWithBadge = css`
  ${SharedIconStyles}
  position: relative;
  .badge {
    background-color: ${COLORS.SHIRAZ_RED};
    position: absolute;
    right: -10px;
    top: -1px;
    border-radius: 10px;
    color: ${COLORS.WHITE};
    display: inline-block;
    font-size: 12px;
    font-weight: ${FONT.FONT_WEIGHT_BOLD};
    line-height: 1;
    min-width: 10px;
    padding: 3px 7px;
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
  }
`;

export const HamburgerBtn = styled.button`
  background-color: transparent;
  padding: 0;
  border: none;
`;

export const UniversalSearchContainer = styled.div`
  height: 100vh;
  width: 100vw;
  top: 0;
  position: fixed;
  background: ${COLORS3.WHITE_100};
  padding: ${SPACING.S24};
  font-weight: ${FONT.WEIGHT.SEMI_BOLD};
`;
